@if (portalSiteUrl && portalApiUrl) {
  <div class="absolute top-0 right-0 w-full">
    <tf-transflo-top-nav
      [homeHref]="portalSiteUrl"
      [portalApiBaseUrl]="portalApiUrl"
      [portalAppUrl]="portalSiteUrl"
      [localOverride]="isLocal() ? localTokens() : undefined"
      (accessTokenVerified)="portalTokenNew.set($event.accessToken)"
    />
  </div>
}
<section
  class="inline-flex h-full w-full flex-row justify-center rounded-r-lg pt-14"
>
  <fw-pages-nav-bar class="flex" />
  <div class="w-full">
    <router-outlet />
  </div>
</section>
